<template>
  <div>
    <form class="mt-4">
      <label class="text-left block font-bold">Contact Information</label>
      <ContactItem 
        v-for="(item, index) in formValues" 
        :key="index"
        :value="item"
        :defaultValues="[item]"
        @remove="formValues.splice(index, 1)"
        @input="(a) => onInput(item, [a.name, a.relationship, a.email, a.phone])">
      </ContactItem>
      <!--ContactItem 
        v-for="(item, index) in formValues" 
        :key="item.id"
        :value="item"
        :itemKey="item.id"
        :defaultValues="(item.id === undefined && defaultValue) ? defaultValue : ''" 
        @remove="formValues.splice(index, 1)"
        @input="(a) => onInput(item, [a.name, a.relationship, a.email, a.phone])">
      </ContactItem-->
      <Button
        @click="addContactItem()"
        type="button"
        color="gray"
        size="md"
        class="rounded-md w-1/4 !shadow m-1">
        + Additional Contact Information
      </Button>
    </form>
  </div>
</template>
<script>
import { mask } from 'vue-the-mask'
import cloneDeep from 'clone-deep'

//import TextField from './formComponents/TextField.vue';
import Button from './Button.vue'
import ContactItem from './items/ContactItem.vue'
import { isArray, isNil, isString } from 'lodash'

export default {
    name: "ContactInfo",
    directives: { mask },
    components: {
      //TextField,
      Button,
      ContactItem
    },
    props: {
      defaultValue: [],
    },
    data() {
      return {
        formValues: [{id: this.itemID, name: '', relationship: '', email: '', phone: ''}],
        componentKey: 0,
        itemID: 0,
      };
    },
    methods: {
      updateValue() {
        this.$emit('input', this.formValues)
      },
      addContactItem() {
        this.itemID += 1
        this.formValues.push({id: this.itemID, name: '', relationship: '', email: '', phone: ''})
      },
      onInput(old, val) {
        old.name = val[0]
        old.relationship = val[1]
        old.email = val[2]
        old.phone = val[3]
        this.updateValue()
      },
      setDefaultContactInfo() {
        if (this.defaultValue && this.checkSchema(this.defaultValue) && this.defaultValue.length > 0) {
          this.formValues = cloneDeep(this.defaultValue)
        }
        else {
          this.formValues = [{ id: this.itemID, name: '', relationship: '', email: '', phone: '' }]
        }

        this.componentKey += 1;
        for (const [i, contact] of this.formValues.entries()) {
          if (contact.relationship === "DATA_MISSING") {
            this.formValues[i].relationship = "";
          }
        }
        this.updateValue()

        this.$emit('defaultValueUsed')
      },
      checkSchema(obj) {
        if (!isArray(obj)) {
          console.warn(`Invalid default value data type in ContactInfo, ${typeof obj}`)
          return false
        }

        for (const [index, contactInfo] of obj.entries()) {
          if (!(isNil(contactInfo.name) || isString(contactInfo.name))) {
            console.warn(`Invalid default value data type in ContactInfo[${index}].name, ${typeof contactInfo.name}`)
            delete contactInfo.name
          }
          if (!(isNil(contactInfo.relationship) || isString(contactInfo.relationship))) {
            console.warn(`Invalid default value data type in ContactInfo[${index}].relationship, ${typeof contactInfo.relationship}`)
            delete contactInfo.relationship
          }
          if (!(isNil(contactInfo.email) || isString(contactInfo.email))) {
            console.warn(`Invalid default value data type in ContactInfo[${index}].email, ${typeof contactInfo.email}`)
            delete contactInfo.email
          }
          if (!(isNil(contactInfo.phone) || isString(contactInfo.phone))) {
            console.warn(`Invalid default value data type in ContactInfo[${index}].phone, ${typeof contactInfo.phone}`)
            delete contactInfo.phone
          }
        }

        return true
      }
    },
    mounted() {
      this.setDefaultContactInfo();
    },
    watch: {
      defaultValue() {
        this.setDefaultContactInfo();
      }
    },
}
</script>
